exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".height-50px[data-v-90007692] {\n  height: 50px;\n  width: auto;\n}\n.collection-schedule-box[data-v-90007692] {\n  background-color: white;\n  border: 1px solid #dee2e6;\n  border-bottom: none;\n}\n.border-bottom[data-v-90007692] {\n  border: 1px solid #dee2e6;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n}", ""]);

// exports
